export const worstReviewRating = 0
export const bestReviewRating = 10
